export class RegulationActionFilterModel {
    UserId: number | null;
    FromDate: string | null;
    ToDate: string | null;
    MappingID: string[] | null;
    Regulator: string[] | null;
    Types: string[] | null;
    Topics: string[] | null;
    ImpactAreas: string[] | null;
    Status: string[] | null;
    Impacts: string[] | null;
    Assessments: string[] | null;
    ActionDateFrom: string | null;
    ActionDateUntil: string | null;
    EffectiveDateFrom: string | null;
    EffectiveDateUntil: string | null;

    SearchQuery: string | null;
    SortKey: string | null;
    IsDesc: boolean | true;
    TakeCount: number | null;
    SkipCount: number | null;
    TotalItems: number | null;
    IsAdvance: boolean;

    constructor() {
        this.UserId = null;
        this.FromDate = null;
        this.ToDate = null;
        this.MappingID = null;
        this.Regulator = null;
        this.Types = null;
        this.Topics = null;
        this.ImpactAreas = null;
        this.Impacts = null;
        this.Status = null;
        this.Assessments = null;
        this.ActionDateFrom = null;
        this.ActionDateUntil = null;
        this.EffectiveDateFrom = null;
        this.EffectiveDateUntil = null;

        this.SearchQuery = null;
        this.SortKey = null;
        this.IsDesc = true;
        this.TakeCount = null;
        this.SkipCount = null;
        this.TotalItems = null;
        this.IsAdvance = false;
    }
}
